import React, { use, useEffect, useState } from "react";
import {
  WorkTypeButton,
  AreaGenContainer,
  ControlDockHeader,
} from "../styled/potree/PotreeControl.styles";
import styled from "styled-components";

import {
  AreaGenerateIcon,
  DeleteIcon,
  PathGenerateIcon,
} from "../../assets/icons/WorkTypeIcons";
import { SubmitButton } from "../styled/potree/PotreeControl.styles";
import {
  useAreaGenerateStore,
  useCesiumStore,
  useCustomAlertStore,
} from "../../Store/store";
import AreaGenerateModal from "../modal/AreaGenerateModal";
import ColorSelectDropdown from "./ColorSelectDropdown";
import {
  DeletePolygonMode,
  GetPolygonModeId,
  PostGeometries,
} from "../../api/cesiumAPI";

const SubmitButtonCustom = styled(SubmitButton)`
  margin-top: 0px;
  font-weight: 500;

  &.active {
    background-color: #ff6b6b4c;
    border: 1px solid #ff6b6b;
    color: #e3e3e3;
  }
  &.active:hover {
    background-color: #ff6b6b;
    color: #e3e3e3;
  }
`;

const WorkTypeContainer = styled.div`
  display: flex;
  gap: 10px;

  width: 100%;
`;

const AreaGenerateContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;
  width: 100%;

  .AreaGenerateSelectContainer {
    display: flex;
    gap: 10px;
    width: 100%;

    select {
      flex-grow: 1;
    }
    .AreaGenerateSelectButton {
      width: 40px;
      height: 40px;
      background-color: rgba(0, 255, 153, 0.1);
      color: #fff;
      border: 1px solid #00ff99;
      border-radius: 4px;
      cursor: pointer;
    }
  }
`;

export default function AreaGenerate() {
  const {
    setIsAreaGenerateOpen,
    setOnConfirm,
    selectedWorkType,
    setSelectedWorkType,
    setName,
    setNewAreaName,
    setSelectedAreaType,
    selectedAreaType,
    setIsAddAreaModeOpen,
    setSelectedAreaColor,
  } = useAreaGenerateStore();

  const {
    editMode,
    setEditMode,
    setPolygonModeIdList,
    polygonModeIdList,
    deletePoint,
    removePoint,
    clearAllPoints,
  } = useCesiumStore();
  const { setTooltip } = useCesiumStore();
  const { showSuccessAlert, showErrorAlert, showInfoAlert } =
    useCustomAlertStore();

  const TabChange = (tab) => {
    setSelectedWorkType(tab);
    setName("");
    setNewAreaName("");
    setSelectedAreaType(selectedAreaType);
    clearAllPoints();
  };

  const handleOpenModal = () => {
    const allPoints = useCesiumStore.getState().allPoints;
    const polygonArea = useCesiumStore.getState().polygonArea;

    if (allPoints.length === 0) {
      showErrorAlert("좌표가 없습니다.", "좌표를 추가해주세요.");
      return;
    }
    setOnConfirm((data) => {
      // 경로 생성 시
      const fetchDataPath = async () => {
        const response = await PostGeometries(allPoints, data);

        if (response.success) {
          showSuccessAlert("영역 저장 성공", "영역이 저장되었습니다.");
        } else {
          showErrorAlert("영역 저장 실패", "영역이 저장되지 않았습니다.");
        }
      };

      // 영역 생성 시
      const fetchDataArea = async () => {
        const response = await PostGeometries(allPoints, data, polygonArea);

        if (response.success) {
          showSuccessAlert("영역 저장 성공", "영역이 저장되었습니다.");
        } else {
          showErrorAlert("영역 저장 실패", "영역이 저장되지 않았습니다.");
        }
      };

      if (selectedWorkType === "pathGenerate") {
        fetchDataPath();
      } else if (selectedWorkType === "areaGenerate") {
        fetchDataArea();
      }
    });
    setIsAreaGenerateOpen(true);
  };

  const handleEditMode = () => {
    setEditMode(!editMode);
    setTooltip({
      visible: false,
      x: 0,
      y: 0,
      content: null,
      pointPosition: null,
    });
    if (editMode === true) {
      showInfoAlert("수정 완료", "위도, 경도가 업데이트 되었습니다.");
    }
  };

  useEffect(() => {
    if (selectedWorkType === "areaGenerate") {
      const fetchPolygonModeId = async () => {
        const polygonModeIdList = await GetPolygonModeId();

        setPolygonModeIdList(polygonModeIdList);
      };
      fetchPolygonModeId();
    }
  }, [selectedWorkType]);

  // 영역 생성 시 영역 색상 선택
  useEffect(() => {
    const OptionObject = polygonModeIdList.find(
      (item) => item.id === selectedAreaType,
    );
    if (OptionObject) {
      setSelectedAreaColor(OptionObject.modeColor);
    } else {
      setSelectedAreaColor("#ff1493");
    }
  }, [selectedAreaType, polygonModeIdList]);

  const handleModalOpen = () => {
    setIsAddAreaModeOpen(true);
  };
  const allPoints = useCesiumStore.getState().allPoints;

  const deletePointFunction = (index, arrayIndex) => {
    if (deletePoint) {
      deletePoint(index);
    }
    removePoint(index);
  };
  const handleClearAllPoints = () => {
    if (clearAllPoints) {
      clearAllPoints();
    }
  };

  const handleDeleteAreaType = async () => {
    try {
      const response = await DeletePolygonMode(selectedAreaType);

      showSuccessAlert("영역 삭제 성공", "영역이 삭제되었습니다.");
      const polygonModeIdList = await GetPolygonModeId();
      setPolygonModeIdList(polygonModeIdList);
    } catch (error) {
      showErrorAlert(
        "영역 삭제 실패",
        "기본 & 저장된 영역은 삭제할 수 없습니다.",
      );
    }
  };
  return (
    <AreaGenContainer>
      <section>
        <ControlDockHeader>
          <h2>영역 생성</h2>
          <p>더블 클릭으로 영역 생성 후 저장할 수 있습니다.</p>
        </ControlDockHeader>
        <main className="AreaGenerateContainer">
          <WorkTypeContainer>
            <WorkTypeButton
              className={selectedWorkType === "pathGenerate" ? "selected" : ""}
              onClick={() => TabChange("pathGenerate")}
            >
              <PathGenerateIcon />
              <span>경로 생성</span>
            </WorkTypeButton>
            <WorkTypeButton
              className={selectedWorkType === "areaGenerate" ? "selected" : ""}
              onClick={() => TabChange("areaGenerate")}
            >
              <AreaGenerateIcon />
              <span>영역 생성</span>
            </WorkTypeButton>
          </WorkTypeContainer>
          <AreaGenerateContainer>
            {selectedWorkType === "areaGenerate" && (
              <>
                <div className="AreaGenerateSelectContainer">
                  <ColorSelectDropdown
                    options={polygonModeIdList}
                    selectedValue={selectedAreaType}
                    onSelect={setSelectedAreaType}
                    placeholder="영역을 선택하세요"
                  />

                  <button
                    onClick={() => handleModalOpen()}
                    className="AreaGenerateSelectButton"
                  >
                    +
                  </button>
                  <button
                    onClick={() => handleDeleteAreaType()}
                    className="AreaGenerateSelectButton"
                  >
                    -
                  </button>
                </div>
              </>
            )}
          </AreaGenerateContainer>

          <div className="AreaGenerateButtonContainer">
            <SubmitButtonCustom
              className={editMode ? "active" : ""}
              onClick={() => handleEditMode()}
            >
              {editMode ? "수정 완료" : "좌표 수정"}
            </SubmitButtonCustom>
            <SubmitButtonCustom onClick={handleClearAllPoints}>
              좌표 초기화
            </SubmitButtonCustom>
          </div>
          <SubmitButtonCustom onClick={handleOpenModal}>
            영역 저장하기
          </SubmitButtonCustom>
        </main>
      </section>
      <section className="AreaSelectContainer">
        <ControlDockHeader>
          <h2>포인트 목록</h2>
          <p>생성된 포인트를 확인할 수 있습니다.</p>
        </ControlDockHeader>
        <main className="AreaSelectList">
          {allPoints.map((point, arrayIndex) => (
            <article className="AreaSelectItem" key={point.index}>
              <h3 className="AreaSelectItemTitle">포인트 {point.index}</h3>
              <p className="AreaSelectItemDescription">
                위도: <span>{point.latitude}</span>
              </p>
              <p className="AreaSelectItemDescription">
                경도: <span>{point.longitude}</span>
              </p>
              <p className="AreaSelectItemDescription">
                거리: <span>{point.length}km</span>
              </p>
              <button
                className="AreaSelectItemDeleteButton"
                onClick={() => deletePointFunction(point.index, arrayIndex)}
                title="포인트 삭제"
              >
                ×
              </button>
            </article>
          ))}
        </main>
      </section>
    </AreaGenContainer>
  );
}
